import React from 'react'
import { Button } from './ui'

/**
 * Модальное окно подтверждения действия (например удаления).
 * @param {string} title - заголовок
 * @param {React.ReactNode} message - текст или разметка сообщения
 * @param {string} confirmLabel - подпись кнопки подтверждения
 * @param {string} cancelLabel - подпись кнопки отмены
 * @param {string} confirmVariant - вариант кнопки подтверждения: 'danger' | 'primary'
 * @param {() => void} onConfirm - обработчик подтверждения
 * @param {() => void} onCancel - обработчик отмены
 * @param {boolean} confirmDisabled - отключить кнопку подтверждения
 * @param {string} error - текст ошибки для отображения внутри модалки
 */
function ConfirmModal({
  title,
  message,
  confirmLabel = 'Подтвердить',
  cancelLabel = 'Отмена',
  confirmVariant = 'danger',
  onConfirm,
  onCancel,
  confirmDisabled = false,
  error = null
}) {
  return (
    <div className="modal-overlay" onClick={onCancel} role="dialog" aria-modal="true" aria-labelledby="confirm-modal-title">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3 id="confirm-modal-title">{title}</h3>
        {message}
        {error && (
          <div className="message message-error" role="alert" style={{ marginTop: 'var(--spacing-md)' }}>
            {error}
          </div>
        )}
        <div className="modal-actions">
          <Button type="button" variant="secondary" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button type="button" variant={confirmVariant} onClick={onConfirm} disabled={confirmDisabled}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmModal
